<span class="font-bold font-size-11 col-6 px-0">
	{{ label }}
</span>
